<igx-snackbar
  #snackbar
  [class]="type"
  [autoHide]="autoHide"
  [positionSettings]="newPositionSettings"
>
  <ng-content></ng-content>
</igx-snackbar>
